import unleash from '@/unleash';

export const venueImaginaryCategory = () =>
  unleash.isEnabled('ImaginaryVenuePhotosUploads') ? 'venue' : undefined;
